export const product = {
  isCalculate: [
    {label: '是', value: 'Y'},
    {label: '否', value: 'N'}
  ],
  isSupportContinuationRate: [
    {label: '是', value: '1'},
    {label: '否', value: '0'}
  ],
  insTypeList: [
    {label: '主险', value: '1'},
    {label: '附加险', value: '2'}
  ],
  // 计划书能力
  planBookFlagList: [
    {label: '支持', value: '1'},
    {label: '不支持', value: '0'}
  ],
  // 投保能力
  insureFlagList: [
    {value: '0', label: '不支持'},
    {value: '1', label: 'CPS投保'},
    {value: '2', label: 'API投保'}
  ],
  // 投保能力 0-不支持 1-cps 2-api 3-CPS/API投保
  singleInsureFlag: [
    {value: '0', label: '不支持'},
    {value: '1', label: 'CPS投保'},
    {value: '2', label: 'API投保'},
    {value: '3', label: 'CPS/API投保'}
  ],
  // 销售状态
  salesStatus: [
    {value: '0', label: '停售'},
    {value: '1', label: '在售'}
    // {value: '2', label: '待售'}
  ],
  // 上架状态
  upshelfStatus: [
    {value: 2, label: '待上架'},
    {value: 1, label: '已上架'},
    {value: 0, label: '已下架'}
  ],
  // 平台产品标识
  platformFlag: [
    {value: 1, label: '平台产品'},
    {value: 0, label: '非平台产品'}
  ],
  // 销售渠道
  salesChannel: [
    {value: '1', label: 'PC出单中心'},
    {value: '2', label: 'APP'}
    // {value: '3', label: '产销对接平台'}
  ],
  // 销售渠道选择
  chooseSalesChannel: [
    {value: '1', label: 'PC出单中心'},
    {value: '2', label: 'APP'},
    // {value: '3', label: '产销对接平台'},
    {value: '0', label: '未配置'}
  ],
  // 商城状态
  statusList: [
    {value: 0, label: '已删除'},
    {value: 1, label: '已启用'},
    {value: 2, label: '待启用'},
    {value: 3, label: '已禁用'}
  ],
  // 分类来源
  sourceList: [
    {value: 1, label: '系统默认'},
    {value: 2, label: '自定义添加'}
  ],
  // 佣金是否显示
  commissionShowFlag: [
    {value: '1', label: '显示'},
    {value: '0', label: '不显示'}
  ],
  // 投保方式
  insureType: [{
    label: '跳链投保', value: 1
  }, {
    label: '联系出单员', value: 2
  }],
  commissionUnitList: [{
    label: '%', value: '1'
  }, {
    label: '元', value: '2'
  }],
  importBusiType: [
    {label: '链接投保批量导入', value: '268'}
  ],
  exportBusiType: [
    {label: '产品列表导出', value: 270},
    {label: '批量导出二维码', value: 266}
  ],
  signStatusList: [
    {label: '已签约', value: 1},
    {label: '未签约', value: 0}
  ],
  managementList: [
    {label: '含管理利益', value: '0'},
    {label: '不含管理利益', value: '1'}
  ]
}
export default {
  product
}



// WEBPACK FOOTER //
// ./src/data/product.js